import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import Layout from '../components/Layout';
// import Timeline from '../components/Timeline';
import { ExternalLink } from '../components/StyledComponents/Links';
import { H3, H4, Paragraph } from '../components/StyledComponents/TextStyles';

// import timelineData from '../../static/timeline-data/data';

const Section = styled.section``;

const About = ({ data, location }) => {
	const siteTitle = data.site.siteMetadata.title;

	return (
		<Layout location={location} title={siteTitle}>
			<Section className="mb-4 sm:mb-6">
				<header>
					<H3
						customClass="pb-4 sm:pb-6"
						style={{ color: 'var(--color-secondary)' }}
					>
						Hi, I am Mohit.
					</H3>
				</header>
				<Paragraph>
					And I am a <strong>Software Engineer</strong>, who loves pretty
					interfaces. I mostly work on the Frontend of websites and apps with
					occasional forays into backend and design. I enjoy working on
					challenging designs and problems. My usual choices for programming
					languages are <strong>JavaScript</strong> and <strong>Python</strong>,
					and these days, I am experimenting with <strong>Rust</strong> and{' '}
					<strong>Swift</strong>.
				</Paragraph>
				<Paragraph>
					I've always been more of a reader/lurker on the internet, but I feel
					it's time to level up and put my thoughts on topics that I am
					passionate about out here, on the web. My goal with this website is to
					be able to structure my thoughts better and hopefully as a result of
					that, write better as well.
				</Paragraph>
				{/* <Paragraph>
					I am a big believer in the paradigm that learning should never stop
					and one should always aspire to learn, improve, and push themselves a
					little harder every day.
				</Paragraph> */}
				<Paragraph>
					Thanks to{' '}
					<strong>
						<ExternalLink href="https://guzey.com/personal/why-have-a-blog/">
							this
						</ExternalLink>
					</strong>{' '}
					post, that provided the last gasp of motivation required to finally
					start working on CunningKruger. I've always wanted to have a personal
					website but never had a clear vision for it. It's still a work in
					progress but I have a few ideas and experiments planned.
				</Paragraph>
			</Section>
			{/* <Section className="mb-4 sm:mb-6">
				<header>
					<H4 customClass="py-4 sm:py-6">Topics I am Interested In</H4>
					<Paragraph>
						<ul>
							<li>Web & App Development</li>
							<li>Human Psychology</li>
						</ul>
					</Paragraph>
				</header>
			</Section> */}
			<Section className="mb-4 sm:mb-6">
				<header>
					<H4 customClass="py-4 sm:py-6">
						What's with the name CunningKruger?
					</H4>
				</header>
				<Paragraph>
					Just an idea I had while reading about the{' '}
					<ExternalLink href="https://www.verywellmind.com/an-overview-of-the-dunning-kruger-effect-4160740">
						Dunning-Kruger
					</ExternalLink>{' '}
					effect. I rarely buy domains based on passing whims (infact, I never
					buy domains), but this one felt unique the moment it popped into my
					head. Also, a few people have chuckled a bit when I told them about
					it, I'll take that as a win.
				</Paragraph>
			</Section>

			{/* <Section className="mb-4 sm:mb-6">
				<header>
					<H4 customClass="py-4 sm:py-6">Timeline</H4>
				</header>

				<Timeline items={timelineData} />
			</Section> */}
		</Layout>
	);
};

export default About;

export const PageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
	}
`;
